function Leads() {
  return <div>Leads</div>
}

export default Leads
